import { ComponentType, ReactNode, Suspense } from 'react';
import ErrorBoundary from './ErrorBoundary';

export let withSuspense = <P extends Record<string, unknown>>(
  WrappedComponent: ComponentType<P>,
  {
    fallback,
    ErrorBoundaryFallbackComponent,
    FallbackComponent,
  }: {
    fallback?: ReactNode;
    ErrorBoundaryFallbackComponent?: ComponentType<Partial<P>>;
    FallbackComponent?: ComponentType<Partial<P>>;
  } = {},
) => {
  let WithSuspense = (props: P) => {
    return (
      <ErrorBoundary
        fallback={
          ErrorBoundaryFallbackComponent ? (
            <ErrorBoundaryFallbackComponent {...props} />
          ) : null
        }
      >
        <Suspense
          fallback={
            FallbackComponent ? <FallbackComponent {...props} /> : fallback ?? null
          }
        >
          <WrappedComponent {...props} />
        </Suspense>
      </ErrorBoundary>
    );
  };
  return WithSuspense;
};

export default withSuspense;
